// Vendor CSS
import 'sweetalert2/dist/sweetalert2.min.css';
import 'notyf/notyf.min.css';

// Volt theme SCSS (compiles Bootstrap + Volt + third-party styles)
import './scss/volt.scss';

// Vendor JS – expose globals needed by legacy scripts and volt-theme
import * as Popper from '@popperjs/core';
import * as bootstrap from 'bootstrap';
import Swal from 'sweetalert2';
import { Notyf } from 'notyf';
import { Datepicker } from 'vanillajs-datepicker';
import noUiSlider from 'nouislider';
import SmoothScroll from 'smooth-scroll';
import simplebar from 'simplebar';
import Chartist from 'chartist';
import 'chartist-plugin-tooltips';

// Expose globals so that inline scripts and volt-theme samples can use them
(window as any).Popper = Popper;
(window as any).bootstrap = bootstrap;
(window as any).Swal = Swal;
(window as any).Notyf = Notyf;
(window as any).Datepicker = Datepicker;
(window as any).noUiSlider = noUiSlider;
(window as any).SmoothScroll = SmoothScroll;
(window as any).simplebar = simplebar;
(window as any).Chartist = Chartist;

// Volt theme initialization
import './volt-theme';

// App shell (sidebar collapse, profile sub-nav)
import './sidebar';

// Global Serbian HTML5 validation messages
import { initSerbianValidation } from './lib/serbian-validation';
initSerbianValidation();

// Localized date inputs (dd.mm.yyyy.) when lang="sr*"
import { initLocalizedDateInputs } from './lib/localized-date-input';
document.addEventListener('DOMContentLoaded', initLocalizedDateInputs);

// Page-specific modules (auto-initialization via data attributes)
import './pages/page-initializer';
import './pages/agency-details';
import './pages/availability-calendar';
import './pages/contract-create';
import './pages/offer-create';
import './pages/offer-edit';
import './pages/offer-index';
import './pages/contract-index';
import './pages/traveller-index';
import './pages/invoice-index';
import './pages/offer-details';
import './pages/dashboard-index';
import './pages/import-session';
import './pages/agency-edit';
import './pages/payment-index';
import './pages/contract-details';
